import React, { useState, useEffect } from 'react';
import {
  CallConnectedOBJ,
  CallOBJ,
  MailOBJ,
  smsOBJ,
  WhatsAppOBJ,
} from '../../../../_utilities/constants';
import WhatsAppConversation from '../../../../components/WhatsAppConversation/WhatsAppConversation';
import { getWhatsappIntegration } from '../../../../_utilities/whatsappContext';
import { SendSMSillu } from '../../../../Icons/SendSMSillu';
import { ContactApplicantIllu } from '../../../../Icons/contactApplicantIllu';
import GetJobId from '../../../../_utilities/GetJobId';
import { useDispatch } from 'react-redux';
import RightSideBar from '../../../../components/Rightsidebar/RightSideBar';
import {
  checkRingCentralApp,
  formatPhoneNumber,
  isLoggedIntoRingCentral,
  redirectToLogin,
  triggerRingOut,
} from '../../../../_utilities/ringCentralUtils';
import * as _ser from '../../../../_redux/_services/ApplicantsSlice';
import { GetTimeZone } from '../../../../_utilities/GetTimeZone';
import { updateLoader } from '../../../../_redux/LoaderSlice';
import getUserDetails from '../../../../_utilities/getUserInfo';
import { updateSnackbar } from '../../../../_redux/SnackbarSlice';
import GenerateTemplate from '../../../../components/GenerateTemplate/GenerateTemplate';
import SendSms from '../../../../components/SendSms/SendSms';
import { Divider } from '@material-ui/core';
import { Button, Link, Stack } from '@mui/material';
import { Notescall } from '../../../../Icons/Notescall';
import CkEditor from '../../../../components/CkEditor/CkEditor';
import GenerateTemplateNew from '../../../../components/GenerateTemplate/GenerateTemplateNew';
import EmailDeliverySummary from '../../../../components/EmailDeliverySummary';

const ApplicantOtherActions = ({
  tabvalue,
  onReceivePropsHandler,
  selectedOption,
  applicantDetails,
}) => {
  return (
    <div
      id={
        tabvalue === 'Call' || tabvalue === 'isImageFalse' ? 'callSection' : ''
      }
    >
      <RightSideBar
        componentData={
          <ComponentRenderData
            isAssociatedProfile={false}
            applicantDetails={applicantDetails}
            jobCode={null}
            onReceiveProps={onReceivePropsHandler}
            selectedOption={selectedOption}
          />
        }
        componentLayout={
          tabvalue === 'Send E-mail'
            ? MailOBJ
            : tabvalue === 'Send SMS'
              ? smsOBJ
              : tabvalue === 'Call'
                ? CallOBJ
                : tabvalue === 'WhatsApp'
                  ? WhatsAppOBJ
                  : tabvalue === 'isImageFalse'
                    ? CallConnectedOBJ
                    : ''
        }
        footerImg={
          tabvalue === 'Send E-mail' ? (
            <SendSMSillu />
          ) : tabvalue === 'Send SMS' ? (
            <SendSMSillu />
          ) : tabvalue === 'Call' ? (
            <ContactApplicantIllu />
          ) : tabvalue === 'WhatsApp' ? (
            ''
          ) : tabvalue === 'isImageFalse' ? (
            ''
          ) : (
            <ContactApplicantIllu />
          )
        }
        onReceiveProps={onReceivePropsHandler}
      />
      <EmailDeliverySummary />
    </div>
  );
};

const ComponentRenderData = ({
  isAssociatedProfile,
  applicantDetails,
  jobCode,
  onReceiveProps,
  selectedOption,
}) => {
  const [callNotes, setCallNotes] = useState(``);
  const [callState, setCallState] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const [connectedTime, setConnectedTime] = useState('');

  const jobId = applicantDetails?.id;
  const isLoggedIn = isLoggedIntoRingCentral();

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedOption !== '') {
      onReceivePropsHandler(false, selectedOption);
    }
    console.log('selectedOption changed:', selectedOption);
  }, [selectedOption]);

  const ckeditor = (data) => {
    setCallNotes(data);
  };

  useEffect(() => {
    let date = new Date();
    setCallNotes(
      `Call Initiated with  ${applicantDetails.firstName} ${GetTimeZone(date)}`
    );
  }, []);

  const handleCallInitiate = async () => {
    dispatch(updateLoader(true));

    try {
      setErrorMessage(''); // Clear any existing errors
      const formattedNumber = formatPhoneNumber(applicantDetails.contactNumber);
      // Check if the RingCentral app is installed
      const appExists = await checkRingCentralApp(formattedNumber);
      console.log('App exists:', appExists);
      if (appExists) {
        dispatch(updateLoader(false));
        // If the app exists, show the message after the user interacts with the app
        setCallState('connected');
        setErrorMessage(
          'We found the RingCentral app. Initiating the call through the app.'
        );
        return;
      }
      // If the app is not found, check if the user is logged in
      if (!isLoggedIn) {
        dispatch(updateLoader(false));
        setErrorMessage('Please login to RingCentral to make a call.');
        return;
      }
      // Proceed with RingOut if logged in but the app is not found
      setCallState('calling');
      setErrorMessage(
        "We don't see the RingCentral app installed. Making the call through RingOut..."
      );
      // Fetch the stored main number and extension
      const companyMainNumber = localStorage.getItem('ringCentralMainNumber');
      const userExtension = localStorage.getItem('ringCentralUserExtension');

      if (!companyMainNumber || !userExtension) {
        dispatch(updateLoader(false));
        setErrorMessage(
          'Unable to retrieve RingCentral user details. Please try logging in again.'
        );
        return;
      }

      const fromNumber = `${companyMainNumber}*${userExtension}`;
      const ringOutResponse = await triggerRingOut(formattedNumber, fromNumber); // Replace with your verified number
      console.log('RingOut response:', ringOutResponse);

      dispatch(updateLoader(false));
      if (
        ringOutResponse &&
        ringOutResponse.status.callStatus === 'InProgress'
      ) {
        setCallState('connected');
        setErrorMessage('We have successfully made the call via RingOut.');
        onReceiveProps(false, 'isImageFalse');
      } else {
        throw new Error('Failed to initiate the call through RingOut.');
      }
    } catch (error) {
      console.error('Call initiation failed:', error);
      setCallState('idle');
      setErrorMessage(
        'An error occurred while trying to make the call. Please try again.'
      );
    }
    let date = new Date();
    setConnectedTime(date);
  };

  const handleLogin = () => {
    redirectToLogin();
  };

  const handleSaveNotes = async (event) => {
    event.preventDefault();
    try {
      const userInfo = await getUserDetails();
      const notePayload = {
        notes: callNotes,
        noteType: 'Call',
        moduleType: 'applicants',
        moduleId: jobId,
        userId: userInfo.userId,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      };
      await dispatch(_ser.addNotesAsync(notePayload)); // Dispatch add notes action
      dispatch(
        updateSnackbar({
          type: 'success',
          message: 'Call notes saved successfully!',
        })
      );
      setCallNotes(''); // Clear notes input
      setCallState('idle'); // Reset state
      onReceiveProps(false, 'close');
      await dispatch(_ser.listNotesAsync(jobId)); // Refresh notes list
      setErrorMessage('');
    } catch (error) {
      console.error('Error saving call notes:', error);
      dispatch(
        updateSnackbar({
          type: 'error',
          message: 'Failed to save call notes. Please try again.',
        })
      );
    }
  };

  const handleCancelCall = () => {
    setCallState('idle');
    setErrorMessage('');
  };

  const onReceivePropsHandler = (pannel, load) => {
    onReceiveProps(false, load);
  };

  const storedTheme = JSON.parse(localStorage.getItem('themeSettings')) || '';

  return (
    <>
      {selectedOption === 'Send E-mail' && (
        <GenerateTemplateNew
          isAssociatedProfile={false}
          applicantDetails={applicantDetails}
          jobCode={null}
          onReceiveProps={onReceivePropsHandler}
          to={'applicants'}
        />
      )}

      {selectedOption === 'Send SMS' && (
        <SendSms
          data={applicantDetails}
          onReceivechildProps={onReceivePropsHandler}
        />
      )}

      {selectedOption === 'WhatsApp' && (
        <WhatsAppConversation
          applicantDetails={applicantDetails}
          integration={getWhatsappIntegration()}
        />
      )}

      {selectedOption === 'Call' && (
        <>
          <div>
            <h3
              style={{
                textAlign: 'left',
                marginTop: '4px',
                marginBottom: '8px',
                fontSize: '22px',
                fontFamily: 'Roboto',
              }}
            >
              Call
            </h3>
            <Divider className="secline" />
            <table style={{ marginTop: '15px', color: '#3E3E3E' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '10px 0px' }}>Applicant Name</td>
                  <td style={{ padding: '10px' }}>:</td>
                  <td style={{ textAlign: 'left', padding: '10px 6px' }}>
                    {applicantDetails.firstName} {applicantDetails.lastName}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '10px 0px', textAlign: 'left' }}>
                    Contact Number
                  </td>
                  <td>:</td>
                  <td style={{ padding: '10px 6px' }}>
                    {applicantDetails.contactNumber}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Error or Login Prompt */}
          {errorMessage && (
            <div style={{ marginTop: '30px' }}>
              <p
                style={{
                  color: callState === 'connected' ? 'green' : 'red',
                  margin: '3px',
                }}
                className="text-left "
              >
                {errorMessage}
              </p>
              {!isLoggedIn && callState === 'idle' && (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: 'var(--primary-bg-color)',
                    borderRadius: '10px',
                    color: 'var(--primary-background-text-color)',
                    marginTop: '20px',
                  }}
                  onClick={handleLogin}
                >
                  Login to RingCentral
                </Button>
              )}
            </div>
          )}

          {/* Call Button */}
          {!errorMessage && callState === 'idle' && (
            <div className="call-button" onClick={handleCallInitiate}>
              <Notescall
                primaryColor={storedTheme?.primaryColor}
                secondaryColor={storedTheme?.secondaryColor}
              />
              <p>Call Applicant</p>
            </div>
          )}

          {/* Calling State */}
          {callState === 'calling' && (
            <div className="content-center">
              <div className="pulse">
                <img
                  src={process.env.PUBLIC_URL + '/assests/img/Notescall.svg'}
                  alt="Calling Icon"
                  className="calling-icon"
                />
              </div>
              <p className="callingtext">Calling Applicant...</p>
            </div>
          )}

          {/* Connected State */}
          {callState === 'connected' && (
            <div className="connected-div">
              <div className="call-connected">
                <img
                  src={process.env.PUBLIC_URL + '/assests/img/phone.svg'}
                  alt=""
                  style={{ height: '23px', width: '23px' }}
                  className="phone-icon"
                />
                <p className="sucesses-text">
                  Successfully Connected With Applicant
                </p>
              </div>
              <p className="text-left" style={{ margin: '3px' }}>
                Add Notes here
              </p>
              <CkEditor
                data={callNotes}
                name="callNotes"
                autoComplete="off"
                onUpdatehandler={(update) => {
                  ckeditor(update.data);
                }}
              />
              <div className="cancelsave-btns" style={{ marginTop: '20px' }}>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="text"
                    sx={{ color: '#FF0000' }}
                    onClick={handleCancelCall}
                    size="small"
                  >
                    <Link
                      href="#"
                      className="cancel-btn"
                      style={{ color: 'red' }}
                      underline="always"
                    >
                      Cancel
                    </Link>
                  </Button>
                  <Button
                    className="savebtn"
                    variant="contained"
                    onClick={handleSaveNotes}
                    size="small"
                    style={{
                      backgroundColor: 'var(--primary-bg-color)',
                      borderRadius: '10px',
                      color: 'var(--primary-background-text-color)',
                    }}
                  >
                    Save
                  </Button>
                </Stack>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ApplicantOtherActions;
